import React, { } from 'react'
import {
  Card, CardBody, CardImage,
  Popover, PopoverBody, PopoverHeader,
  ListGroup, ListGroupItem
} from 'mdbreact'

const url = 'https://api.lushplans.com/_vendors/?token=APyOXy3w60i2MpJ7F8PMAy-neZY3pjnOnaZUGB5BEomqc73vOCdmp6NtASyVR-KU3nYojdBZYzC6ghjz6On8Wm6rq34M7A-iNPGBtpiXIBL-MgGNoULDCFYiGfUPxZ1dwQYPqjeSH45nDOhRdjhcQaxcMiVSkk1QPTOJLiYkgYW-ISVGdtfL9s5efJlSEmAySy6FpPeINZAx9TMATKkgDRv77oZoYviGihxmCWdLYKhpsVT_xTY5w2RGv02LNwwH0Bp3ZnHc_sApC1_BQKsVjAHy5eYAHijQmFcXpL1fLSjVqH_mWkMD6FUuz4dJUnomR2VRWpNVcZQ83zigmaWgfz1Jjtnzz6DDkvLkC2JONeOq12J2yl6XRlvVNcq7nC8gRCRP3SOMSFhg{!EXTERNALAUTH!}&_id=google.com***ID***101394503087099242953&stat='

const vendorMapping = {
  'ta4pa': 'Top Vendor', // ta4pa
  'ta4patahara22': 'Top 3', // ta4patahara22
  'ta4pafa3va2': 'Top 5', // ta4pafa3va2
  'ta4pata2na': 'Top 10', // ta4pata2na
  'ta4patawa2nataya': 'Top 20', // ta4patawa2nataya
  'ta4pafa2fataya': 'Top 50', // ta4pafa2fataya
  'ta4paha5nadara2da': 'Top 100', // ta4paha5nadara2da
  '1lala': 'Default' // 1lala
}

const mappingKeys = Object.keys(vendorMapping)

const FilterItem = props => {
  return (
    <option value={props.type}>{props.type}</option>
  )
}

const VendorCard = props => {
  return (
    <div className='col-md-4 col-xs-12 col-sm-6 col-lg-3 col-center-block'>
      <Card>
        <CardImage className='card-img' src={props.image} alt='' />
        <CardBody>
          <h5 className='pink-text'><i className='fa fa-trophy' /> {props.types[0].toUpperCase()} </h5>
          <div className='card-body'>
            <h4 className='card-title text-center vendorName'>
              <strong>
                {props.profile && props.profile.name ? props.profile.name : props.id.replace('@', '') }
              </strong>
            </h4>
            <h6> <i className='fa fa-heart rating' />
              {'  ' + props.likes.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} lush feels
            </h6>
            <h6> <i className='fa fa-edit rating' />
              {'  ' + props.appearance.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} lush weddings
            </h6>
            <h6> <i className='fa fa-comments rating' />
              {'  ' + props.comments.toLocaleString(navigator.language, { minimumFractionDigits: 0 })} lush taps
            </h6>
            <hr />
            <p className='card-text text-center'>
              <a type='button' className='btn-floating btn-sm text-center'
                href={'https://www.instagram.com/' + props.id.replace('@', '')} target='_blank' rel='noopener noreferrer'><i className='fa fa-instagram' /></a>
              <a type='button' className='btn-floating btn-sm text-center'
                href={'#'} target='_blank' rel='noopener noreferrer'><i className='fa fa-map' /></a>
              <a type='button' className='btn-floating btn-sm text-center'
                href={'#'} target='_blank' rel='noopener noreferrer'><i className='fa fa-facebook' /></a>
              <a type='button' className='btn-floating btn-sm text-center'
                href={'#'} target='_blank' rel='noopener noreferrer'><i className='fa fa-twitter' /></a>
            </p>
            <hr />
          </div>
          <div style={{display: 'flex', width: '100%'}}>
            <button className='btn-save btn btn-primary btn-sm' id='claimBtn' hidden={props.profile.city}>
              <a href={'https://vendor.lushplans.com/?' +
              'ig=' + props.id.replace('@', '') +
              '&country=' + 'Nigeria' +
              '&state=' + 'Lagos' +
              '&city=' + 'Lagos' +
              '&name=' + props.id.replace('@', '') +
              '&type=' + props.types[0].toUpperCase()}
                target='_blank' rel='noreferrer noopener'>Claim</a>
            </button>
            <Popover
              style={{display: 'flex', width: '100vw'}}
              component='button'
              popoverBody='View'
              className='btn btn-sm btn-primary pull-right click-btn'>
              <PopoverHeader>{props.id}</PopoverHeader>
              <PopoverBody>
                <img className='img-fluid' src={props.image} alt='' />
                <br />
                <ListGroup>
                  <h4>Basic Information</h4>
                  <ListGroupItem><span>Name: </span><span> {props.profile && props.profile.name ? props.profile.name : props.id.replace('@', '') }</span></ListGroupItem>
                  <ListGroupItem><span>Feels: </span><span> {props.likes.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></ListGroupItem>
                  <ListGroupItem><span>Weddings: </span><span> {props.appearance.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></ListGroupItem>
                  <ListGroupItem><span>Taps: </span><span> {props.comments.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</span></ListGroupItem>
                  <h4>Contact Information</h4>
                  <ListGroupItem><span>Address: </span><span> {props.profile && props.profile.address ? props.profile.address : 'Not entered' }</span></ListGroupItem>
                  <ListGroupItem><span>Email: </span><span> {props.profile && props.email ? props.email : 'Not entered' }</span></ListGroupItem>
                  <ListGroupItem><span>Phone: </span><span> {props.profile && props.profile.phone ? props.profile.phone : 'Not entered' }</span></ListGroupItem>
                  <ListGroupItem><span>City: </span><span> {props.profile && props.profile.city ? props.profile.city : 'Not entered' }</span></ListGroupItem>
                </ListGroup>
              </PopoverBody>
            </Popover>
          </div>
        </CardBody>
      </Card>
      <hr />
    </div>
  )
}

export {url, vendorMapping, mappingKeys, FilterItem, VendorCard}



// WEBPACK FOOTER //
// ./src/List/List.consts.js